






import Vue from "vue";
interface AccordionState {
  collapsedIndex: number | undefined;
  update: (value: number) => void;
}

interface Provide {
  getAccordionState: () => AccordionState;
}

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: false
    }
  },
  provide(): Provide {
    return {
      getAccordionState: this.accordionState
    };
  },

  methods: {
    accordionState(): AccordionState {
      return {
        collapsedIndex: this.value,
        update: this.updateIndex
      };
    },
    updateIndex(value: number) {
      const newvalue = value === this.value ? undefined : value;
      this.$emit("input", newvalue);
    }
  }
});
